import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, timeout: 20000 });

export const fetchMeta = () => api.get('/site/meta').then(r => r.data);
export const fetchDatasets = () => api.get('/datasets').then(r => r.data);
export const fetchTopMps = (limit = 12) => api.get(`/mps/top?limit=${limit}`).then(r => r.data);
export const fetchAllMps = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return api.get(`/mps/all?${q}`).then(r => r.data);
};
export const fetchMp = (slug) => api.get(`/mps/${slug}`).then(r => r.data);
export const searchMps = (q) => api.get(`/mps/search?q=${encodeURIComponent(q)}`).then(r => r.data);
export const fetchNews = (limit = 12) => api.get(`/news?limit=${limit}`).then(r => r.data);
export const fetchQuarters = () => api.get('/quarters').then(r => r.data);
export const fetchImmigrationCategories = () => api.get('/immigration/categories').then(r => r.data);
export const fetchDisabilityData = () => api.get('/disability').then(r => r.data);
export const fetchHousingData = () => api.get('/housing').then(r => r.data);

export const PARTY_COLORS = {
  LIB: '#D71920',
  CPC: '#1A4782',
  NDP: '#F58220',
  BQ: '#33B2CC',
  GPC: '#3D9B35',
  IND: '#6B7280',
};

export const PARTY_NAMES = {
  LIB: 'Liberal',
  CPC: 'Conservative',
  NDP: 'NDP',
  BQ: 'Bloc Québécois',
  GPC: 'Green',
  IND: 'Independent',
};

export const fmtMoney = (n) => {
  if (n == null) return '$0';
  return '$' + Math.round(n).toLocaleString('en-CA');
};

export const fmtMoneyShort = (n) => {
  if (n >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)} billion`;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)} million`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${Math.round(n).toLocaleString('en-CA')}`;
};
